import { render, staticRenderFns } from "./NotifyChoirModal.vue?vue&type=template&id=3637daec&scoped=true&"
import script from "./NotifyChoirModal.vue?vue&type=script&lang=ts&"
export * from "./NotifyChoirModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637daec",
  null
  
)

export default component.exports